import { useQuery } from "@tanstack/react-query";
import { downloadDocumentCategory } from "../api";
import { TrackDocumentType } from "../types";
import { useParams } from "react-router-dom";
import { showToast } from "@/modules/common/utils";
import { TOAST_IDS, ToastType } from "@/modules/common/types";

export const useDownloadDocumentCategory = (category: TrackDocumentType) => {
  const { trackId } = useParams();

  const { data, isSuccess, refetch, isFetching } = useQuery({
    queryKey: ["download-document-category", category],
    queryFn: ({ queryKey }) => {
      const [, category] = queryKey;
      return downloadDocumentCategory({
        trackUId: trackId as string,
        documentType: category as TrackDocumentType,
      });
    },
    enabled: false,
    onSuccess: (data) => {
      const downloadBlob = (blob: Blob, filename: string) => {
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      };

      downloadBlob(data.data, "documents.zip");
    },
    onError: () => {
      showToast({
        type: ToastType.ERROR,
        message: "Failed to download document",
        toastId: TOAST_IDS.DOWNLOAD_DOCUMENT_ERROR,
        options: {
          position: "bottom-left",
          autoClose: 3000,
        },
      });
    },
  });

  return {
    isFetching,
    refetch,
    data,
    isSuccess,
  };
};
